import { BaseTypeModel } from '../base/base-type.model';

export class IngredientTypeModel extends BaseTypeModel {
    public static fields: Array<string> = BaseTypeModel.fields.concat([
        'image'
    ]);

    public image?: string;
}
